import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, ControlLabel} from 'react-bootstrap'
import Textarea from 'react-textarea-autosize'
import {observer, inject} from 'mobx-react'
import '../containers/css/Spinner.css'
import '../components/css/PoorTextField.css'
 
class PoorTextField extends Component {
      
    constructor(params) {
        super(params)
        this.charAmount = this.charAmount.bind(this)
        this.state = {
            characterCount: 0,
            desc: '',
            showStatus: false,
            showSaved: false,
            showSaving: false,
        }
    }

    componentWillReceiveProps(nextProps){
        // console.log('componentWillReceiveProps nextProps.description',nextProps.description)
        if(nextProps.description){
            this.setState({characterCount:nextProps.description.length, desc: nextProps.description})
        }else{
            this.setState({characterCount:0, desc: ''})
        }
    }

    wordCount(e){
        var currentText = e.target.value
        this.setState({
            characterCount : currentText.length,
            showSaved: true,
        })
        if(this.props.tool)
            this.props.onChange(currentText, this.props.tool, this.props.id)
        else
            this.props.onChange(currentText, this.props.id)
    }

    charAmount(){
        let char = null
        if (this.state.characterCount >= 501){
            char = <span style={{color: 'red'}}>{this.state.characterCount}/500</span>
            return char
        }
        else if (this.state.characterCount < 501){
            char = <span style={{color: '#A9A9A9'}}>{this.state.characterCount}/500</span>
            return char
        }
    }

    statusSymbol(){
        const {stores} = this.props
        const {store} = stores
        if (!store.online) {
            return <span className='poorTextReconnect'><strong>Reconnecting... If you reload, changes will be lost!</strong></span>
        } else if (store.saving){
            return <div> <span className='glyphicon glyphicon-refresh Spinner' style={{fontSize:15+'px', color: 'green'}}></span><span className='poorTextSaving'> Saving...</span></div>
        } else if (this.state.showSaved){
            return <span className='poorTextSaved'>Saved!</span>
        } else {
            return null
        }
    }
 
    render(){

        // if(this.props.id === 'impact')
        //     console.log('render this.props:',this.props, this.state.desc)
        return (
            <FormGroup>
                {this.props.label &&
                    <ControlLabel>{this.props.label}</ControlLabel>
                }
                <Textarea
                    className='form-control'
                    onFocus={(e) => this.setState({showStatus: true})}
                    onBlur={(e) => this.setState({showStatus: false, showSaved: false})}
                    style={{minHeight: 35+'px', lineHeight: 22+'px', maxWidth: 100+'%'}}
                    value={this.state.desc}
                    placeholder={this.props.placeholder}
                    onChange={(e) =>{this.wordCount(e)}}
                    minRows={6}
                    maxRows={6}
                />
                <div>
                    <div className='poorTextStatusSymbol'>
                        {this.state.showStatus === true &&
                        <div>
                            {this.statusSymbol()}
                        </div>
                        }
                    </div>
                    <div className='poorTextCharCount'>
                        {this.charAmount()}
                    </div>
                </div>
            </FormGroup>
        
        )
    }
}

PoorTextField.propTypes = {
    id: PropTypes.string,
    tool: PropTypes.string,
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    wordColor: PropTypes.string,
}

export default inject("stores")(observer(PoorTextField))




// WEBPACK FOOTER //
// ./src/components/PoorTextField.js